import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-253ed00a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "toggle-profile-sharing"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "share-profile-toggle",
  class: "toggle-label"
}, "Allow other members in your organisation to see your profile?", -1))
const _hoisted_4 = { class: "btn-container" }

import { ref, onBeforeMount } from "vue";
import axios from "axios";
import { debug as d } from "debug";
import { UserSharingSettingsApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-profile-settings',
  props: {
    userId: {}
  },
  setup(__props: any) {

const debug = d("cs.ProfileSettings");

const props = __props;

const isSharingProfile = ref<UserSharingSettingsApiModel | null>(null);

async function getUserSharingSettings() {
  try {
    const response = await axios.get("/api/usersharingsettings");
    isSharingProfile.value = response.data;
  } catch (e) {
    debug(e);
  }
}

async function submitUserSharingSettings() {
  try {
    await axios.post("/api/usersharingsettings", isSharingProfile.value);
  } catch (e) {
    debug(e);
  }
}

onBeforeMount(async () => {
  await getUserSharingSettings();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isSharingProfile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSharingProfile.value.shareUserProfileWithOrganisation) = $event)),
            value: isSharingProfile.value.shareUserProfileWithOrganisation,
            onChange: submitUserSharingSettings,
            type: "checkbox",
            class: "toggle-switch-checkbox",
            id: "share-profile-toggle",
            name: "share-profile-toggle",
            "data-test": "share-profile-toggle"
          }, null, 40, _hoisted_2), [
            [_vModelCheckbox, isSharingProfile.value.shareUserProfileWithOrganisation]
          ]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: `/user/profile/${props.userId}`,
        class: "btn btn-default",
        "data-test": "view-my-profile"
      }, {
        default: _withCtx(() => [
          _createTextVNode("View my profile")
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})